import { Injectable } from '@angular/core';
import {BehaviorSubject} from "rxjs/BehaviorSubject";
import { Http, Response, Headers, RequestOptions} from '@angular/http';
import { Configuration } from '../config/config';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/throw';
import {User} from '../models/Users'
import {userRole} from "../models/userRole";
import { Router} from "@angular/router";
import { GlobalService } from '../Services/global.service';
import * as jwt_decode from 'jwt-decode';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class AuthService {
  private loggedIn = new BehaviorSubject<boolean>(false);
  public currentUser = User;
  isLoginComm = {
    id: null,
    communityName : null,
    communityID : null,
    purpose : null,
    image_data: null
  };
  _userActionOccured: Subject<void> = new Subject();
  get userActionOccured(): Observable<void> { return this._userActionOccured.asObservable() };

  constructor(private http: Http, private route: Router, private globalService : GlobalService,private cookieService: CookieService) {
    this.loggedIn.next(false);
  }

  get isUserLoggedIn() {
    let user = false;
    if (this.getToken()) {
      // alert("token receive");
      user = true;
    }else {
      // alert("token not receive");
      user = false;
    }
    // alert(user);
    this.loggedIn.next(user);
    console.log("logged in observable",this.loggedIn.asObservable());
    return this.loggedIn.asObservable();
  }

  login(oUser) {
    let headers = new Headers({ 'Content-Type': 'application/json'});
    headers.append('Cache-Control', 'no-cache');
    headers.append('Pragma', 'no-cache');
    let options = new RequestOptions({headers: headers});
    return this.http.post(Configuration.ServerWithApiUrl+'/login', JSON.stringify(oUser), options).do((response: Response) => {
        if (response.json().success) {
            this.currentUser = response.json().data;
            let userObj: any = {};
            userObj.user = response.json().data;
            console.log("user login data for setting current object",userObj.user);
            userObj.token = response.json().token;
            userObj.msg = response.json().message;
            localStorage.setItem('currentUser', JSON.stringify(userObj));
            localStorage.setItem('profile_pic', JSON.stringify(userObj.user.profile_pic));
            localStorage.setItem('userRole',userObj.user.role);
            let commResObj = {
              community_id : userObj.user.community_id,
              community_name : userObj.user.community_name,
              resource_config : userObj.user.resource_config
            };
            localStorage.setItem('CommResources', JSON.stringify(commResObj));
        }
        response.json();
    })
    .catch(this.handleError);
}

  logout() {
    let that = this;
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    let headers = new Headers({ 'Content-Type': 'application/json'});
    let Typechecking = localStorage.getItem('Typechecking');
    headers.append('Cache-Control', 'no-cache');
    headers.append('Pragma', 'no-cache');
    headers.append('Authorization', `${currentUser.token}`);
    let options = new RequestOptions({headers: headers});

    let oUser = {
      log_id : currentUser.user.log_id,
      user_id : currentUser.user.userid
    };

    return this.http.post(Configuration.ServerWithApiUrl+'/logout', oUser, options)
      .do((response: Response) => {
          this.currentUser = null;
          this.loggedIn.next(false);
          if(Typechecking == 'COGNITO_AUTHENTICATION'){
            let loginUrl = this.cookieService.get("loginUrl");
            let loginStr = '/login';
            localStorage.clear();
            this.route.navigate([loginStr],{ queryParams: {token: loginUrl}});
            response.json();
          }else{
            const CompanyData = JSON.parse(localStorage.getItem('CompanyData'));
            console.log("CompanyData", CompanyData);
            const CommResources = localStorage.getItem('CommResources') ? JSON.parse(localStorage.getItem('CommResources')) : null;
            let loginStr = '/login';
            if (this.globalService.isLoginComm.communityID != null && this.globalService.isLoginComm.communityID == CompanyData.communityID) {
              localStorage.clear();
              localStorage.setItem('CompanyData', JSON.stringify(CompanyData));
              CommResources && CommResources.community_id == this.globalService.isLoginComm.communityID ? localStorage.setItem('CommResources', JSON.stringify(CommResources)) : '';
              let obj = {
                communityID: CompanyData.communityID
              };
              let val = window.btoa(JSON.stringify(obj));
              loginStr = loginStr + '/' + val;
            } else {
              this.globalService.isLoginComm = {
                id: null,
                communityName: null,
                communityID: null,
                purpose: null,
                image_data: null
              };
              localStorage.clear();
              localStorage.clear();
            }
            this.route.navigate([loginStr]);
            response.json();
          }
        })
        .catch(function (error : Response) {
          let res = error.json();
          if(res.statusCode === 'exp-token' || res.statusCode == 'no-token'){
            that.currentUser = null;
            that.loggedIn.next(false);

            const CompanyData = JSON.parse(localStorage.getItem('CompanyData'));
            const CommResources = localStorage.getItem('CommResources') ? JSON.parse(localStorage.getItem('CommResources')) : null;
            let loginStr = '/login';
            if(that.globalService.isLoginComm && that.globalService.isLoginComm.communityID == CompanyData.communityID){
              localStorage.clear();
              localStorage.setItem('CompanyData',JSON.stringify(CompanyData));
              CommResources && CommResources.community_id == this.globalService.isLoginComm.communityID ? localStorage.setItem('CommResources',JSON.stringify(CommResources)) : '';
              let obj = {
                communityID : CompanyData.communityID
              };
              let val = window.btoa(JSON.stringify(obj));
              loginStr = loginStr + '/' + val;
            }else{
              that.globalService.isLoginComm = {
                id: null,
                communityName : null,
                communityID : null,
                purpose : null,
                image_data: null
              };
              localStorage.clear();
              localStorage.clear();
            }
/*            that.cookieService.set( 'defaultLang', 'English', 365, '/');
            localStorage.setItem('defaultLang', 'English');
            localStorage.setItem('defaultLangId', 'English');
            that.globalService.setLangId('English');
            that.translate.use('English');*/
            that.route.navigate([loginStr]);
          }
          return Observable.throw(error.json());
        });
  }

  isTokenExpired(token?: string): boolean {
    if(!token) token = this.getToken();
    if(!token) return true;

    const date = this.getTokenExpirationDate(token);
    if(date === undefined) return false;
    return !(date.valueOf() > new Date().valueOf());
  }

  getTokenExpirationDate(token: string): Date {
    const decoded = jwt_decode(token);
    if (decoded.exp === undefined) return null;
    const date = new Date(0);
    date.setUTCSeconds(decoded.exp);
    return date;
  }

  getToken(){
    const theuser = localStorage.getItem('currentUser') ? JSON.parse(localStorage.getItem('currentUser')).token : null;
    // alert("in get token")
    // console.log("the user",theuser);
    return theuser;
  }
  private handleError(error: Response) {
    var res = error.json();
    if(res.statusCode === 'exp-token' || res.statusCode == 'no-token'){
      this.logout().subscribe( log =>{
        if(log.success){
          localStorage.clear();
        }
      });
    }
    return Observable.throw(error.json());
  }

  refreshToken(){
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Cache-Control', 'no-cache');
    headers.append('Pragma', 'no-cache');
    let options = new RequestOptions({ headers: headers });
    const theuser:any = JSON.parse(localStorage.getItem('currentUser'));
    const data = {
      user_id: theuser.user.userid
    };
    return this.http.post(Configuration.ServerWithApiUrl+'/refresh',data,options)
      .map(res=>res.json())
      .do(response=>{
        let userObj: any = {};
        userObj.user = response.data;
        userObj.token = response.token;
        userObj.msg = response.message;
        localStorage.setItem('currentUser', JSON.stringify(userObj));
      })
      .catch(error => {
        return this.handleError(error);
      });
  }

  getJwtToken() {
    const theuser = JSON.parse(localStorage.getItem('currentUser'));
    return theuser ? theuser.token : '';
  }

  notifyUserAction() {
    this._userActionOccured.next();
  }
}




// WEBPACK FOOTER //
// ./src/app/Services/AuthGard.service.ts